export default (id, city) => {
  switch (id) {
    // 家庭
    case 631559: // 家庭环境量表中文版（FES-CV）
      return 'https://www.yuque.com/docs/share/5289eb36-e64c-4f04-9bc7-8b76c329b4df?# 《家庭环境量表中文版（FES-CV）》'
    // 问题行为
    case 993547: // 中学生手机依赖量表
      return 'https://www.yuque.com/docs/share/35480f8b-ec9a-455b-ae1f-1c050c382a6e?# 《中学生手机依赖量表》'
    case 742762: // 攻击性问卷(AQ修订版)
      return 'https://www.yuque.com/docs/share/c5bfdc4e-f8db-47a2-bc3e-48879eb7c7e9?# 《攻击性问卷(AQ修订版)》'
    case 523798: // 网络成瘾量表
      return 'https://www.yuque.com/docs/share/934e5677-fa2e-4716-90fa-7dd7557532d8?# 《网络成瘾量表》'
    // 亲子沟通
    case 993549: // 亲子沟通方式问卷
      return 'https://www.yuque.com/docs/share/d403d73a-adc1-4c18-b972-9b2c33ac1cab?# 《亲子沟通方式问卷》'
    case 452613: // 父母教养方式量表(EMBU)
      return 'https://www.yuque.com/docs/share/34aa5712-9ddb-4ec6-b907-6e300bcbe638?# 《父母教养方式量表(EMBU)》'
    // 自我认识与发展
    case 993536: // 期待性平衡回答量表
      return 'https://www.yuque.com/docs/share/e044ac97-6a46-43fb-8137-f09854e03dd4?# 《期待性平衡回答量表》'
    case 993531: // 青少年心理韧性量表
      return 'https://www.yuque.com/docs/share/bf55012d-1867-4a59-8b4d-47f9b1a948f0?# 《青少年心理韧性量表》'
    case 993522: // 心理弹性量表（RS-25）
      return 'https://www.yuque.com/docs/share/5614b31c-c23c-40eb-9d2e-cdc320736f9b?# 《心理弹性量表（RS-25）》'
    case 916837: // 自尊量表
      return 'https://www.yuque.com/docs/share/4b262abd-9e1a-413b-a303-f37854993d61?# 《自尊量表》'
    case 774575: // 一般自我效能感量表（GSES）
      return 'https://www.yuque.com/docs/share/7f5d254e-c6c2-4ca0-8de3-a7274a43709b?# 《一般自我效能感量表（GSES）》'
    case 687871: // 自我和谐量表（SCCS）
      return 'https://www.yuque.com/docs/share/7f64152c-d482-442c-85a7-4f61f4c0a24c?# 《自我和谐量表（SCCS）》'
    case 659317: // 成就动机量表（AMS）
      return 'https://www.yuque.com/docs/share/ff42b984-ee5f-4fbe-8d1e-b28e44947f0b?# 《成就动机量表（AMS）》'
    case 453913: // 正念注意觉知量表
      return 'https://www.yuque.com/docs/share/5b5da9d6-8db2-47f6-adc7-4382101be227?# 《正念注意觉知量表》'
    case 355576: // Piers-Harris儿童自我意识量表
      return 'https://www.yuque.com/docs/share/624898a7-2a1c-47eb-892f-70868b4d896d?# 《Piers-Harris儿童自我意识量表》'
    // 职业倾向
    case 993534: // 职业锚问卷
      return 'https://www.yuque.com/docs/share/8d175a73-4a0c-4daf-a98d-02987e5f4727?# 《职业锚问卷》'
    case 947452: // MBTI量表
      return 'https://www.yuque.com/docs/share/78c3a196-2967-4dae-bebe-07c25ad1341b?# 《MBTI量表》'
    case 796328: // Super职业价值观量表（WVI）
      return 'https://www.yuque.com/docs/share/cf84e2be-ee2d-4e10-bfe3-e0089b32ba92?# 《Super职业价值观量表（WVI）》'
    case 545489: // 霍兰德职业倾向测验量表（完整版）
      return 'https://www.yuque.com/docs/share/310d4afa-c565-4c60-9efb-eec2fc147bd4?# 《霍兰德职业倾向测验量表（完整版）》'
    case 527344: // 一般决策风格量表(GDMS)
      return 'https://www.yuque.com/docs/share/4c6f1584-dc4b-4b74-850d-9b2ae672a091?# 《一般决策风格量表(GDMS)》'
    case 335811: // 霍兰德职业兴趣测量表（60题简版）
      return 'https://www.yuque.com/docs/share/05ea5e53-b31d-4377-92cc-13fca443d241?# 《霍兰德职业兴趣测量表（60题简版）》'
    // 学习相关
    case 993546: // 学习状态测查量表
      return 'https://www.yuque.com/docs/share/37fff844-e3bd-4b59-a7fe-1e7a71a7500a?# 《学习状态测查量表》'
    case 993539: // 青少年学业情绪问卷
      return 'https://www.yuque.com/docs/share/efc0c16f-0b3b-43ac-ac0a-93d5822898bd?# 《青少年学业情绪问卷》'
    case 992291: // 青少年时间管理倾向量表
      return 'https://www.yuque.com/docs/share/5a2d543c-8d2c-44b8-b9af-1a17a8344f18?# 《青少年时间管理倾向量表》'
    case 944784: // 学习障碍筛查量表（PRS）
      return 'https://www.yuque.com/docs/share/2ec906b0-7f3d-42d6-90b1-92423fcc812b?# 《学习障碍筛查量表（PRS）》'
    case 837459: // 学校气氛问卷（初中生版）（PSCI-M）
      return 'https://www.yuque.com/docs/share/ccc88dfe-8237-4bda-9425-8764e7871352?# 《学校气氛问卷（初中生版）（PSCI-M）》'
    case 832898: // Soloman学习风格量表
      return 'https://www.yuque.com/docs/share/149373a0-d5c1-4b2e-a632-b405951b3e4e?# 《Soloman学习风格量表》'
    case 681362: // 考试焦虑量表（TAS）
      return 'https://www.yuque.com/docs/share/198553af-cee0-4f2e-bed0-4c9d5df3789b?# 《考试焦虑量表（TAS）》'
    case 657813: // 多动症诊断标准量表
      return 'https://www.yuque.com/docs/share/71115704-8096-4073-86bf-f96ed3c52139?# 《多动症诊断标准量表》'
    case 647565: // 学习态度与学习方法综合测评量表
      return 'https://www.yuque.com/docs/share/18571d84-74ef-42f6-9a8a-1e27127e99b5?# 《学习态度与学习方法综合测评量表》'
    case 261471: // 学习适应性测验（AAT）
      return 'https://www.yuque.com/docs/share/76bb840a-44b6-42da-b54a-b54133dfcaa2?# 《学习适应性测验（AAT）》'
    case 243234: // 青少年学习倦怠量表
      return 'https://www.yuque.com/docs/share/5b8817ee-3a0b-430f-a8fd-83c2cc7bb6ae?# 《青少年学习倦怠量表》'
    // 压力应对与适应
    case 993532: // 青少年生活事件量表
      return 'https://www.yuque.com/docs/share/bbabeef5-a0b2-4855-a71e-03961ca1e802?# 《青少年生活事件量表》'
    case 993526: // 应对方式问卷
      return 'https://www.yuque.com/docs/share/1f7f54bb-b5d1-42db-9aff-5a393f1b4825?# 《应对方式问卷》'
    case 898143: // 知觉压力量表
      return 'https://www.yuque.com/docs/share/2aea0909-63b2-4ba5-b1c4-ce2d5a14c637?# 《知觉压力量表》'
    case 833372: // 青少年生活事件量表(ASLEC)
      return 'https://www.yuque.com/docs/share/adf9ad2a-a46d-4cd9-9dbc-13c410377a5c?# 《青少年生活事件量表(ASLEC)》'
    case 167115: // 中学生心理适应性量表
      return 'https://www.yuque.com/docs/share/d1b2585e-525b-4a86-b573-0405acf65673?# 《中学生心理适应性量表》'
    // 人际交往
    case 676156: // 交流恐惧自陈量表(PRCA-24)
      return 'https://www.yuque.com/docs/share/4ac47b82-6048-4ab6-bc9f-b6515a860446?# 《交流恐惧自陈量表(PRCA-24)》'
    case 584479: // 领悟社会支持量表(PSSS)
      return 'https://www.yuque.com/docs/share/6c522e6d-c40e-4c95-b8fe-372c7fb49fca?# 《领悟社会支持量表(PSSS)》'
    case 581279: // 孤独量表（UCLA）
      return 'https://www.yuque.com/docs/share/f98d3488-22fe-4841-9fe6-cdadf8f5d485?# 《孤独量表（UCLA）》'
    case 554811: // 人际信任量表
      return 'https://www.yuque.com/docs/share/27ef13dc-9f24-400a-ab88-1d74a106c331?# 《人际信任量表》'
    case 531555: // 教师期望量表
      return 'https://www.yuque.com/docs/share/5c5d0afa-85c4-4b4a-a4e0-d817360e1e7c?# 《教师期望量表》'
    case 242716: // 人际关系综合诊断量表
      return 'https://www.yuque.com/docs/share/5087e614-cb4b-4c5e-a2fb-0b0eb9e04f2d?# 《人际关系综合诊断量表》'
    case 225465: // 师生关系问卷
      return 'https://www.yuque.com/docs/share/a44494e0-79bb-47c3-8a3e-55078cb4cee3?# 《师生关系问卷》'
    case 153785: // 交往焦虑量表（IAS）
      return 'https://www.yuque.com/docs/share/f869bc32-1531-4981-861d-af1429076e35?# 《交往焦虑量表（IAS）》'
    case 143921: // 儿童社交焦虑量表(SASC)
      return 'https://www.yuque.com/docs/share/50b29296-23aa-4708-8506-d7cdc13b2ca0?# 《儿童社交焦虑量表(SASC)》'
    // 心理健康
    case 993544: // 青少年危机筛查问卷（小学版）
      if (city === 450900) {
        return 'https://www.yuque.com/bndawg/sddy0x/peucrgs4c9nk24cd?singleDoc# 《青少年心理危机筛查量表V2023（小学版）》'
      } else {
        return 'https://www.yuque.com/docs/share/4f1f8982-55c8-4ee8-b103-67beea299d3b?# 《青少年心理危机筛查量表（小学版）》'
      }
    case 993548: // 青少年心理危机症状筛查量表
      return 'https://www.yuque.com/docs/share/cceeee80-5ce9-41e7-9d1d-7a31ecaddadc?# 《青少年心理危机症状筛查量表》'
    case 993530: // 青少年睡眠问题量表
      return 'https://www.yuque.com/docs/share/2c4a611a-6c58-45ce-b3aa-d3444e1c9670?# 《青少年睡眠问题量表》'
    case 993542: // 学生疫后心理状态调查问卷
      return 'https://www.yuque.com/docs/share/eefd2410-8144-4448-8424-6692eabb49f8?# 《学生疫后心理状态调查问卷》'
    case 993533: // 青少年心理健康量表
      return 'https://www.yuque.com/docs/share/fb870bc5-2e31-401d-a2c5-9df861e9cf1d?# 《青少年心理健康量表》'
    case 993541: // 青少年心理危机筛查量表（初高中）
      if (city === 450900) {
        return 'https://www.yuque.com/bndawg/sddy0x/sck3eqz0g2koo1r1?singleDoc# 《青少年心理危机筛查量表V2023（初高中）》'
      } else {
        return 'https://www.yuque.com/docs/share/2037c7d7-d30a-4392-b606-e31213aceaa0?# 《青少年心理危机筛查量表（初高中）》'
      }
    case 224988: // 疲劳量表-14（FS-14）
      return 'https://www.yuque.com/docs/share/787bc957-ef3d-42ad-b6fd-da8fa8abe0b5?# 《疲劳量表-14（FS-14）》'
    case 982257: // 匹兹堡睡眠质量指数(PSQI)
      return 'https://www.yuque.com/docs/share/3e38e8a6-ae44-4e39-b71f-b287fa83f5ba?# 《匹兹堡睡眠质量指数(PSQI)》'
    case 841169: // 心理健康诊断测验(MHT)
      return 'https://www.yuque.com/docs/share/debf3720-3719-49df-a36a-b6439982520e?# 《心理健康诊断测验(MHT)》'
    case 824993: // 贝克抑郁自评量表（BDI-13）
      return 'https://www.yuque.com/docs/share/7d7ab17f-9a7f-499c-b40b-05f188829c04?# 《贝克抑郁自评量表（BDI-13）》'
    case 815483: // 自杀意念自评量表(SIOSS)
      return 'https://www.yuque.com/docs/share/de727e31-e3f6-43ff-ad08-872d37265262?# 《自杀意念自评量表(SIOSS)》'
    case 673529: // 青少年情绪状态量表
      return 'https://www.yuque.com/docs/share/4e532cde-713a-4a86-86c9-3898171da694?# 《青少年情绪状态量表》'
    case 638453: // 抑郁自评量表（SDS）
      return 'https://www.yuque.com/docs/share/ca64874b-2b4e-46ad-b7d4-eb46106fdb74?# 《抑郁自评量表（SDS）》'
    case 621323: // 中学生心理健康量表（MSSMHS）
      return 'https://www.yuque.com/docs/share/4a691109-ce41-47be-8197-5e22f656ec13?# 《中学生心理健康量表（MSSMHS）》'
    case 244894: // 自杀态度问卷(QSA)
      return 'https://www.yuque.com/docs/share/7181a896-d9c6-4110-99a8-3081c3e4faa2?# 《自杀态度问卷(QSA)》'
    case 236591: // 症状自评量表（SCL-90）
      return 'https://www.yuque.com/docs/share/7c0f18e3-d035-4a28-9c1a-f5181541728a?# 《症状自评量表（SCL-90）》'
    case 199693: // 失眠严重指数量表(ISI)
      return 'https://www.yuque.com/docs/share/34a5a27e-b20e-4de7-98b6-556b0fca6230?# 《失眠严重指数量表(ISI)》'
    case 137856: // 儿童抑郁量表（CDI）
      return 'https://www.yuque.com/docs/share/d06b1900-97c1-4cc2-9d64-d4684d360d5f?# 《儿童抑郁量表（CDI）》'
    case 831259: // 流调中心抑郁问卷（CES-D）
      return 'https://www.yuque.com/docs/share/0fce4deb-6667-4da2-bab0-ae30935b8da9?# 《流调中心抑郁问卷（CES-D）》'
    case 916421: // 焦虑自评量表(SAS)
      return 'https://www.yuque.com/docs/share/9755839b-1530-44ba-91cd-02fd6209f20a?# 《焦虑自评量表(SAS)》'
    case 532173: // 青春期性心理健康量表
      return 'https://www.yuque.com/docs/share/a5dd5749-cbd0-4fa5-b241-462d1cd1b169?# 《青春期性心理健康量表》'
    case 995002:
      return 'https://www.yuque.com/bndawg/sddy0x/qd6rur8b8riu1ppf?singleDoc# 《青少年身心健康评估量表》'
    case 995003:
      return 'https://www.yuque.com/bndawg/sddy0x/qd6rur8b8riu1ppf?singleDoc# 《青少年身心健康评估量表》'
    case 995004:
      return 'https://www.yuque.com/bndawg/sddy0x/sz84obaqsrcs71il?singleDoc# 《创伤后应激障碍症状清单》'
    case 995005:
      return 'https://www.yuque.com/bndawg/sddy0x/wilz23a69dsdcutq?singleDoc# 《性态度量表中文版》'
    // 能力与人格
    case 993537: // 卡特尔16种人格问卷（16PF）
      return 'https://www.yuque.com/docs/share/74b79162-0f28-4aff-9ab8-e416ae8c95d2?# 《卡特尔16种人格问卷（16PF）》'
    case 993540: // 多元智能量表（简版）
      return 'https://www.yuque.com/docs/share/4e45bae2-43b4-4cd0-8858-37fb49461543?# 《多元智能量表（简版）》'
    case 985753: // 大五人格测试量表（NEO-FFI）
      return 'https://www.yuque.com/docs/share/69194af7-b3cb-4dee-9a53-b3118f87f028?# 《大五人格测试量表（NEO-FFI）》'
    case 852625: // 情绪智力量表(EIS)
      return 'https://www.yuque.com/docs/share/e3e7fb30-e63a-4be0-92ac-27ddf4a3e100?# 《情绪智力量表(EIS)》'
    case 875681: // 中文Frost多维度完美主义量表(FMPS)
      return 'https://www.yuque.com/docs/share/aee54b92-bb29-4d84-81ab-73233a6e1668?# 《中文Frost多维度完美主义量表(FMPS)》'
    case 882329: // 状态-特质焦虑问卷(STAI)
      return 'https://www.yuque.com/docs/share/a1569a42-9350-4779-bf65-b9025a189bca?# 《状态-特质焦虑问卷(STAI)》'
    case 657528: // 艾森克人格问卷EPQ-C（少年版）（7-15岁）
      return 'https://www.yuque.com/docs/share/4af0b15a-e443-4665-ac0f-70747f7a2623?# 《艾森克人格问卷EPQ-C（少年版）（7-15岁）》'
    case 568797: // 威廉斯创造力倾向测试量表
      return 'https://www.yuque.com/docs/share/bb6d246e-ffb8-4ba7-8107-395625236d49?# 《威廉斯创造力倾向测试量表》'
    case 154193: // 艾森克人格问卷（16岁及以上）
      return 'https://www.yuque.com/docs/share/d7259abd-3a7d-4126-af86-95e964c8394f?# 《艾森克人格问卷（16岁及以上）》'
    case 118399: // 多元智能量表（完整版）
      return 'https://www.yuque.com/docs/share/9a9d9bf9-7e6d-487e-a8f3-9c2e022cec72?# 《多元智能量表（完整版）》'
    case 147196: // 主动性人格量表（PPS）
      return 'https://www.yuque.com/docs/share/5142e29a-e420-4704-b290-4f76271f3e52?# 《主动性人格量表（PPS）》'
    case 786464: // 3-7岁儿童气质量表（CPTS）
      return 'https://www.yuque.com/docs/share/2c646dc1-6c50-4f55-b591-db6e9ac118bd?# 《3-7岁儿童气质量表（CPTS）》'
  }
}
